import { gql } from '@apollo/client';

export const GET_PERIOD_GROUP_PERIODS = gql`
  query GetPeriodGroupPeriods($input: PeriodGroupPeriodsInput!) {
    periodGroupPeriods: getPeriodGroupPeriods(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          label
          periodDate
          periodNumber
        }
      }
    }
  }
`;
